import { COLUMNS_MAPPER } from "../constants";

export const getFormattedMapMetric = (statistic, unit) => {
  let cube_column = `${statistic}__${unit}`;

  const metric = COLUMNS_MAPPER[cube_column];

  return metric;
};
